<template lang="pug">
.t-content
  section.info-sec
    .max-container
      .gbox-wrap.slot
        //- .not-mobile.justify-content-end.mt-2
          .gbox-search-box.ss-search-box.aaa
            .search-games
              .iicon.iicon-alter
                img(src='assets/img/search-icon.png')
              input.form-control(type='text' v-model="searchinput" placeholder='Search')
        .gbox-menu
          .gbox-menu-prov
            .gprovbox(:class="{'aaa': providerSelected === 2}" @click="selectOption(2)")
              img(src='images/provider/epicwin.png')
              span EpicWin
            .gprovbox(:class="{'aaa': providerSelected === 0}" @click="selectOption(0)")
              img(src='assets/img/provider/alize.png')
              span Alize
            .gprovbox(:class="{'aaa': providerSelected === 1}" @click="selectOption(1)")
              img(src='assets/img/provider/spribe.png')
              span Spribe
          .g-search
            .gbox-search.ss-search(@click="toggleSearch")
              .iicon
                img(src='/images/search-icon.png')
            .gbox-search-box.ss-search.box.aaa(v-if="showSearch")
              .search-games
                input.form-control(type='text' v-model="searchinput" placeholder='Search')
              span.search-cancel.ss-search-cancel.pointer.ms-2(@click="cancelSearch")
                i.fa-solid.fa-circle-xmark
        alize(v-if="providerSelected === 0" :searchinput="searchinput")
        spribe(v-if="providerSelected === 1" :searchinput="searchinput")
        epicwin(v-if="providerSelected === 2" :searchinput="searchinput")
</template>
<script>
import tabs from '@/views/default/_tabs.vue'
import alize from '@/components2/minigame/_alize.vue'
import spribe from '@/components2/minigame/_spribe.vue'
import epicwin from '@/components2/minigame/_epic2.vue'
export default {
  // metaInfo:{
  //   title: 'EpicWin Minigames | Quick & Fun Games',
  //   meta:[
  //     {vmid: "description",name: 'description', content: "Experience fast paced games that are fun, exciting, but yet challenging at EpicWin. Play now for endless entertainment. Sign up at EpicWin today!"}
  //   ],
  // },
  components:{
    tabs,
    alize,
    spribe,
    epicwin
  },
  data(){
    return{
      providerSelected: 2,
      showLobby:true,
      showModal:false,
      providerList:[
        // "queenmaker",
        // "Mega",
      ],
      searchinput: "",
      showSearch: false,
      feedback: {
        success: true,
        status: ""
      },
      metaData: []
    }
  },
  // metaInfo(){
  //   if(this.metaData.length> 0){
  //     return{
  //       title: this.metaData[0].meta_title || 'EpicWin Malaysia',
  //       meta:[
  //         { name: 'description',content: this.metaData[0].meta_desc },
  //         { name: "keywords", content: this.metaData[0].meta_keywords },
  //         { name: "author", content: this.metaData[0].meta_author },
  //         { name: "publisher", content: this.metaData[0].meta_publisher },

  //         { property: 'og:title', content: this.metaData[0].meta_title },
  //         { property: 'og:description', content: this.metaData[0].meta_desc },
          
  //       ],
  //       link: [
  //         { rel: 'canonical', href: this.metaData[0].meta_canonical }, // Sets the canonical URL
  //       ],
  //     }
  //   }else{
  //     return{
  //       title: 'EpicWin Malaysia',
  //       meta:[
  //         { name: 'description',content: 'EpicWin Malaysia' },
  //       ],
  //     }
  //   }
  // },
  computed: {
    getSlotSelected(){
      return this.$store.getters.slotSelected
    },
    getProvider(){
      return this.providerList[this.providerSelected]
    },
  },
  // watch:{
  // 	getSlotSelected(newState, oldState){
  // 		this.providerSelected = newState
  // 	}
  // },
  beforeDestroy(){
    // this.$store.dispatch("user/setSlotSelected", 0)
  },
  mounted(){
    // window.scroll(0,0)
    // this.providerSelected = this.getSlotSelected
    // this.getSeo()
    window.scroll(0,0)
  },
  methods:{
    getSeo(){			
      var temp = window.location.pathname.split("/")
      let page_name = temp[temp.length-1]
      let domain_name = window.location.hostname
			this.$store
				.dispatch("user/getSeo", {page_name, domain_name})
				.then(response => {
					this.loading = false;
					this.feedback.success = response.success
					if (this.feedback.success == true) {
						if(response.data.length > 0){
							// this.$store.dispatch("user/seoInfo", response.data[0])
              this.metaData = response.data
						}
					} else {
						if((typeof response.status) != 'object'){
							this.$helpers.showDialog(vm.$tc("ui.attention"), vm.$tc("message.list." + response.status), "info", this)
						}       
					}
				})
				.catch(response => {
					this.loading = false;
					var vm = this;
					if((typeof response.status) != 'object'){
						this.$helpers.showDialog(vm.$tc("ui.attention"), vm.$tc("message.list." + response.status), "info", this)
					}
				});
		},
    toggleSearch(){
			this.showSearch = !this.showSearch
		},
		cancelSearch(){
			this.showSearch = false
			this.searchinput = ""
		},
    closeModal(){
      this.showModal = false
    },
    showProvider(){
      this.showModal = true
      // $('.modal-filbox').addClass('aaa')
      $('body').addClass('noscroll')
    },
    changeProvider(option){
      if(option !== this.providerSelected){
        this.providerSelected = option
      }
      this.showModal = false
      $('body').removeClass('noscroll')
      this.showFav = false
    },
    selectOption(target){
      this.showLobby = false
      // this.$store.dispatch("user/setSlotSelected", target)
      this.providerSelected = target
    },
  }
}
</script>
<style lang="scss" scoped>
.iimg{
  cursor: pointer;
}
.gprovbox{
  width: 80px;
}
</style>